import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import EntitiesLayout from 'src/features/entity/components/EntitiesLayout';
import EntityDashboard from 'src/features/entity/components/EntityDashboard';
import GroupsTable from 'src/features/entity/components/table/GroupsTable';
import PeopleTable from 'src/features/entity/components/table/PeopleTable';
import { PATH } from 'src/features/navigation/utils/constants';
import useHasPermissions from 'src/hooks/useHasPermissions';

const EntitiesRoutes = () => {
    const permissionAccessEntities = useHasPermissions([PERMISSION.ACCESS_ENTITIES]);

    const defaultRoutePath = (() => {
        if (permissionAccessEntities) return `/${PATH.ENTITIES}/people`;
        if (permissionAccessEntities) return `/${PATH.ENTITIES}/organisations`;

        return '/';
    })();

    return (
        <Routes>
            <Route path="" element={<EntitiesLayout />}>
                <Route index element={<Navigate to={defaultRoutePath} replace />} />
                {permissionAccessEntities && <Route path="people" element={<PeopleTable />} />}
                {permissionAccessEntities && <Route path="organisations" element={<GroupsTable />} />}
            </Route>
            {permissionAccessEntities && <Route path=":type/:id" element={<EntityDashboard />} />}
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    );
};

export default EntitiesRoutes;
